import { AdminAppState, AdminPanelName, HistoryStack } from '../../../state';
import { getAdminPanelsState } from '../get-admin-panels-state';

export const getAdminPanelsHistory = (
  state: AdminAppState,
): HistoryStack<AdminPanelName> => getAdminPanelsState(state).history;
